import React from 'react'
import { ReactComponent as MotoBikeIcon } from '../assets/icons/MotoBike.svg'
import vehicleCar from '../assets/images/vehicle_car.png'
import vehicleElectricMotorbike from '../assets/images/vehicle_electric_motorbike.png'
import vehicleMotorbike from '../assets/images/vehicle_motorbike.png'

export const CUSTOMER_RECEIPT_STATUS_TO_TEXT = {
  NEW: 'Mới',
  PROCESSING: 'Đang xử lý',
  PENDING: 'Chờ xử lý',
  FAILED: 'Thất bại',
  SUCCESS: 'Thành công',
  CANCELED: 'Đã hủy'
}

export const VIHCLE_TYPES_STATE = {
  CAR: {
    value: 1,
    label: 'Ô tô',
    icon: <img src={vehicleCar} alt="icon" />
  },
  OTHER_VEHICLES: {
    value: 10,
    label: 'Phương tiện khác',
    icon: <MotoBikeIcon />
  },
  TRAILERS: {
    value: 20,
    label: 'Rơ moóc',
    icon: <MotoBikeIcon />
  },
  MOTO_BIKE: {
    value: 10,
    label: 'Xe máy',
    icon: <img src={vehicleMotorbike} alt="icon" />
  },
  ELECTRIC: {
    value: 40,
    label: 'Xe điện',
    icon: <img src={vehicleElectricMotorbike} alt="icon" />
  }
}

export const PAYMENT_TYPE_CODE = {
  ATM_BANK: 'ATM_BANK',
  MOMO: 'MOMO',
  GTEL_PAY: 'GTELPAY',
  VNPAY: 'VNPAY',
  ZALOPAY: 'ZALOPAY',
  VIETTEL_PAY: 'VIETTEL_PAY',
  TA_MOVE: 'TA_MOVE'
}

export const PAYMENT_TYPE = {
  ATM_BANK: 1,
  MOMO: 2,
  MOMO_BANK: 2,
  GTEL_PAY: 3,
  VNPAY: 4,
  ZALOPAY: 5,
  VIETTEL_PAY: 6,
  TA_MOVE: 7,
  SEPAY: 8,
  VIETTEL_MONEY: 9,
  SHOPEEPAY: 10,
  BAOKIM: 11,
  KIMNGAN: 12,
  VNPAY_INAPP: 13,
  VNPAYAPP_INAPP: 13,
  GTELPAY_INAPP: 14,
  VIETTEL_MONEY_GATEWAY: 15
}

// Mapping theo những cái truyền lên params đã gửi khách hàng
export const PAYMENT_TYPE_PARAMS = {
  ATM_BANK: ['bank'],
  MOMO_BANK: ['momo'],
  GTEL_PAY: ['gtelpay'],
  VNPAY: ['vnpay'],
  VNPAYAPP_INAPP: ['vnpayapp_inapp', 'vnpayappinapp'],
  ZALOPAY: ['zalopay'],
  VIETTEL_PAY: ['viettelpay', 'viettel_pay'],
  TA_MOVE: ['tamove'],
  SEPAY: ['sepay'],
  VIETTEL_MONEY: ['viettelmoney', 'viettel_money'],
  SHOPEEPAY: ['shopeepay', 'shopee_pay'],
  BAOKIM: ['baokim'],
  KIMNGAN: ['kimngan', 'kim_ngan']
}

export const PAYMENT_QR_METHOD = {
  PAYMENT_METHOD_ID: 1, // Thanh toán qua ngân hàng VietQR
  PAYMENT_METHOD_INTERPRISE: 2, // Thanh toán qua ngân hàng VietQR Interprise
  MOMO_PAYMENT_METHOD_ID: 3, // Thanh toán qua MOMO
  GTELPAY_PAYMENT_METHOD_ID: 4, // Thanh toán qua Gtelpay
  ZALOPAY_PAYMENT_METHOD_ID: 5, // Thanh toán qua Zalopay
  VIETQR_INTERPRISE_TAMOVE: 6, // Thanh toán qua ngân hàng VietQR Interprise TAMove
  VNPAY_PAYMENT_METHOD_ID: 7, // Thanh toán qua VNPAY
  SEPAY_PAYMENT_METHOD_ID: 8, // Thanh toán qua Sepay
  SHOPEEPAY_PAYMENT_METHOD_ID: 10, // Thanh toán qua ShopeePay
  BAOKIM_PAYMENT_METHOD_ID: 11, // Thanh toán qua ShopeePay
  KIMNGAN_PAYMENT_METHOD_ID: 12, // Thanh toán qua Kim Ngân
  VNPAYINAPP_PAYMENT_METHOD_ID: 13, // Thanh toán qua VNPAY INAPP
  TAMOVExGTELINAPP_PAYMENT_METHOD_ID: 14, // Thanh toán qua TAMOVExGTEL
  TTDKxGTELINAPP_PAYMENT_METHOD_ID: 15, // Thanh toán qua TTDKxGTEL
  VTMxTAMOVE_PAYMENT_METHOD_ID: 16 // Thanh toán qua TTDKxGTEL
}

export const VEHICLE_TYPE = {
  CAR: 1,
  OTHER: 10,
  RO_MOOC: 20,
  MOTOBIKE: 30,
  ELECTRIC_MOTORBIKE: 40
}
